// Keep in sync with ArticlesHelper::VALID_TRANSITION_SOURCES.
const TRANSITION_SOURCES = [
  "manga_ranking",
  "final_episode_recommend",
  "manga_recommend",
];

// Keep in sync with ArticlesHelper::VALID_ENTRY_SOURCES.
// Only these modules may claim the entry source slot; anything else leaves it
// open so the first eligible module clicked afterwards still records.
const ENTRY_SOURCES = [
  "manga_ranking",
  "SP_ranking",
  "PC_ranking",
  "promotion",
  "next_article",
  "recommended_article",
  "next_episode_manga",
  "previous_episode_manga",
  "all_episode_manga",
  "first_episode_manga",
  "manga_rensai",
];

const init = () => {
  const links = document.querySelectorAll("a[data-content-source]");
  links.forEach((link) => {
    link.addEventListener("click", () => {
      const navigationSource = link.getAttribute("data-content-source");
      if (navigationSource) {
        try {
          // Only discovery modules write. Any other value leaves the previous
          // one untouched, which is what keeps the value from being overwritten
          // by navigation modules such as next_episode_manga.
          if (TRANSITION_SOURCES.indexOf(navigationSource) !== -1) {
            sessionStorage.setItem("transition_source", navigationSource);
          }
          if (ENTRY_SOURCES.indexOf(navigationSource) !== -1 && !sessionStorage.getItem("entry_source")) {
            sessionStorage.setItem("entry_source", navigationSource);
          }
        } catch (e) {
          console.error(
            "[NavigationSource] Failed to save (Private Mode?):",
            e,
          );
        }
      }
    });
  });
};

export default { init };
